import React, { useState } from 'react';
import axios from 'axios';
import '../App.css';
import appointmentImage from './pexels-pixabay-263402.jpg';
import Header from '../Components/Header'; // Make sure the path is correct

const Appointment = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    doctor: '',
    date: '',
    time: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        'http://127.0.0.1:8787/api/appointments',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200 && response.data.success) {
        alert(
          `Appointment successfully booked for ${formData.name} with Dr. ${formData.doctor} on ${formData.date} at ${formData.time}!`
        );
        setFormData({
          name: '',
          email: '',
          phone: '',
          doctor: '',
          date: '',
          time: '',
        });
      } else {
        alert('Failed to book appointment. Please try again later.');
      }
    } catch (error) {
      console.error('There was an error!', error);
      alert('Something went wrong. Please try again later.');
    }
  };

  return (
    <div className="appointment-page">
      {/* ✅ Shared Header */}
      <Header />

      {/* Banner */}
      <section
        style={{
          backgroundImage: `url(${appointmentImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '50px 20px',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <div
          style={{
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(1px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: '15px',
            padding: '40px 30px',
            color: '#000',
            maxWidth: '500px',
            width: '100%',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
          }}
        >
          <h2 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '20px' }}>
            Book an Appointment
          </h2>
          <p style={{ fontSize: '16px', marginBottom: '30px' }}>
            To book an appointment, please log in to your account.
          </p>
          <a
            href="/login"
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              padding: '10px 25px',
              borderRadius: '5px',
              textDecoration: 'none',
              fontWeight: 'bold',
              transition: 'background-color 0.3s ease',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#218838')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')}
          >
            Login
          </a>
        </div>
      </section>

      {/* Form */}
      <section className="appointment-form-section">
        <div className="container">
          <h2>Appointment Booking Form</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label htmlFor="doctor">Select Doctor</label>
              <select id="doctor" name="doctor" value={formData.doctor} onChange={handleInputChange} required>
                <option value="">Select a Doctor</option>
                <option value="Mandip Singh">Dr. Mandip Singh (Internal Medicine)</option>
                <option value="Rajeev Malhotra">Dr. Rajeev Malhotra (General Surgery)</option>
                <option value="Meenakshi Gupta">Dr. Meenakshi Gupta (Pediatrics)</option>
                <option value="A.K. Verma">Dr. A.K. Verma (Cardiology)</option>
                <option value="Simran Kaur">Dr. Simran Kaur (Gynecology)</option>
                <option value="Ravi Singh">Dr. Ravi Singh (Physiotherapist)</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="date">Select Date</label>
              <input type="date" id="date" name="date" value={formData.date} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label htmlFor="time">Select Time</label>
              <input type="time" id="time" name="time" value={formData.time} onChange={handleInputChange} required />
            </div>

            <button type="submit" className="submit-btn">Book Appointment</button>
          </form>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us-section">
        <div className="container">
          <h2>Why Choose Chaman Hospital?</h2>
          <ul className="reasons-list">
            <li>✅ Experienced doctors and healthcare professionals</li>
            <li>✅ State-of-the-art facilities and technology</li>
            <li>✅ Affordable care with the PMKVY card for eligible patients</li>
            <li>✅ 24/7 emergency and ambulance services</li>
            <li>✅ Compassionate, patient-centered care</li>
          </ul>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="container">
          <h2>What Our Patients Say</h2>
          <div className="testimonial">
            <p>"The staff at Chaman Hospital took great care of me during my surgery. I felt at ease the entire time!"</p>
            <strong>- Manish Kumar, Patiala</strong>
          </div>
          <div className="testimonial">
            <p>"I am so grateful for the doctors at Chaman Hospital. They truly care about their patients' well-being."</p>
            <strong>- Geeta Rani, Bahadurgarh</strong>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Need Immediate Assistance?</h2>
          <p>Our team is always ready to help you. Whether it's an emergency or a scheduled consultation, we are here for you.</p>
          <a href="/contact" className="btn-secondary">Contact Us Now</a>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital, Bahadurgarh, Patiala. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Appointment;
